<template>
	<div class="input-question">
		<div class="position-relative">
			<input type="text"
				v-model="inputText"
				@keyup.enter="evaluateAnswer()"
				:disabled="question.answerStatus !== null"
				placeholder="Po zadání stiskněte ENTER">
			<div class="input-question__icon">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 548.176 328.91" width="100%"
					v-if="question.answerStatus === null">
					<g transform="translate(0 -109.633)">
						<g>
							<path d="M537.468,120.342a35.214,35.214,0,0,0-25.841-10.709H36.545a35.208,35.208,0,0,0-25.837,10.709A35.215,35.215,0,0,0,0,146.179V401.994a35.211,35.211,0,0,0,10.708,25.837,35.208,35.208,0,0,0,25.837,10.712H511.627a36.566,36.566,0,0,0,36.549-36.549V146.179A35.223,35.223,0,0,0,537.468,120.342ZM511.627,401.994H36.545V146.179H511.627Z"/>
							<path d="M77.657,365.445h27.408q4.569,0,4.569-4.568V333.469c0-3.039-1.52-4.568-4.569-4.568H77.657c-3.044,0-4.568,1.529-4.568,4.568v27.408Q73.089,365.44,77.657,365.445Z"/>
							<path d="M77.657,292.362h63.954c3.045,0,4.57-1.53,4.57-4.572V260.38q0-4.568-4.57-4.568H77.657q-4.566,0-4.568,4.568v27.41C73.089,290.832,74.613,292.362,77.657,292.362Z"/>
							<path d="M77.657,219.268h27.408q4.569,0,4.569-4.57V187.292q0-4.569-4.569-4.57H77.657q-4.566,0-4.568,4.57V214.7Q73.089,219.265,77.657,219.268Z"/>
							<path d="M397.43,328.9H150.751q-4.569,0-4.57,4.572v27.4c0,3.039,1.524,4.572,4.57,4.572h246.67q4.569,0,4.572-4.572v-27.4Q401.994,328.907,397.43,328.9Z"/>
							<path d="M182.725,287.79c0,3.042,1.523,4.572,4.565,4.572H214.7c3.044,0,4.565-1.53,4.565-4.572V260.38q0-4.568-4.565-4.568H187.29q-4.563,0-4.565,4.568v27.41Z"/>
							<path d="M150.751,219.268h27.406q4.569,0,4.57-4.57V187.292q0-4.569-4.57-4.57H150.751q-4.569,0-4.57,4.57V214.7Q146.181,219.265,150.751,219.268Z"/>
							<path d="M255.813,287.79c0,3.042,1.524,4.572,4.568,4.572h27.408c3.046,0,4.572-1.53,4.572-4.572V260.38q0-4.568-4.572-4.568H260.381q-4.566,0-4.568,4.568v27.41Z"/>
							<path d="M223.837,219.268h27.406q4.569,0,4.57-4.57V187.292q0-4.569-4.57-4.57H223.837q-4.569,0-4.57,4.57V214.7Q219.267,219.265,223.837,219.268Z"/>
							<path d="M328.9,287.79c0,3.042,1.525,4.572,4.564,4.572H360.88c3.045,0,4.564-1.53,4.564-4.572V260.38q0-4.568-4.564-4.568H333.468q-4.559,0-4.564,4.568Z"/>
							<path d="M470.513,328.9h-27.4q-4.569,0-4.572,4.572v27.4c0,3.039,1.526,4.572,4.572,4.572h27.4q4.569,0,4.572-4.572v-27.4Q475.085,328.907,470.513,328.9Z"/>
							<path d="M296.928,219.268h27.411q4.569,0,4.565-4.57V187.292q0-4.569-4.565-4.57H296.928q-4.569,0-4.565,4.57V214.7Q292.361,219.265,296.928,219.268Z"/>
							<path d="M370.018,219.268h27.4q4.569,0,4.572-4.57V187.292q0-4.569-4.572-4.57h-27.4q-4.569,0-4.572,4.57V214.7Q365.445,219.265,370.018,219.268Z"/>
							<path d="M401.991,287.79c0,3.042,1.522,4.572,4.568,4.572h63.953c3.046,0,4.572-1.53,4.572-4.572v-100.5q0-4.569-4.572-4.57h-27.4q-4.569,0-4.572,4.57v68.52H406.56q-4.569,0-4.568,4.568v27.41Z"/>
						</g>
					</g>
				</svg>
				<svg v-if="question.answerStatus === 'answeredCorrectly'"
					width="22px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19.162">
					<path d="M24.548,54.323,22.355,52.13a1.558,1.558,0,0,0-2.193,0L9.581,62.726,4.839,57.968a1.493,1.493,0,0,0-1.1-.451,1.493,1.493,0,0,0-1.1.451L.452,60.162a1.558,1.558,0,0,0,0,2.194L6.29,68.194l2.194,2.194a1.558,1.558,0,0,0,2.194,0l2.194-2.194L24.548,56.517a1.558,1.558,0,0,0,0-2.194Z" transform="translate(0 -51.678)"/>
				</svg>
				<svg v-if="question.answerStatus === 'answeredIncorrectly'"
					width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
					<path d="M8981.835,5919.737,8976,5913.9l-5.834,5.834a1.044,1.044,0,0,1-1.475,0l-2.386-2.383a1.045,1.045,0,0,1,0-1.475l5.835-5.835-5.835-5.834a1.045,1.045,0,0,1,0-1.475l2.386-2.385a1.04,1.04,0,0,1,1.473,0l5.835,5.835,5.836-5.835a1.043,1.043,0,0,1,1.475,0l2.384,2.383a1.044,1.044,0,0,1,0,1.477l-5.834,5.835,5.834,5.834a1.041,1.041,0,0,1,0,1.475l-2.384,2.383a1.04,1.04,0,0,1-1.475,0Z" transform="translate(-8966.001 -5900.044)"/>
				</svg>
			</div>
		</div>

		<!-- Upozornění, pokud nezadal žádný input -->
		<b-alert
			variant="danger"
			:show="noInput"
		>
			Napište prosím výsledek
		</b-alert>

		<!-- Správná odpověď, pokud zodpoví špatně -->
		<div
			v-if="question.answerStatus === 'answeredIncorrectly'"
			class="bg-warning px-3 py-3 rounded mt-2"
		>
			Správná odpověď: <b>{{ correctAnswers[0] }}</b>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "InputQuestion",

	props: ['questionIndex'],
	
	data() {
		return {
			inputText: null,

			question: null,

			correctAnswers: [],

			noInput: false,
		};
	},

	// Příprava dat před tím, než se začne cokoliv vykonávat
	created() {
		this.question = this.$store.state.testData.questions[this.$props.questionIndex];
		this.prepareChoicesForInputQuestion();
	},
	methods: {
		...mapActions([
			'correctlyEvaluatedAnswer',
			'incorrectlyEvaluatedAnswer',
		]),

		prepareChoicesForInputQuestion() {
			// Rozparsování
			let parsedAnswer = this.parseChoices(this.question.answer);

			if (parsedAnswer.body.querySelector('p')) { // Pokud jsou správné odpovědi definovány pouze pod sebou (bez odrážkového / číslovaného seznamu)
				parsedAnswer.querySelectorAll("p").forEach((item, i) => {
					this.correctAnswers.push(item.innerText);
				});
			} else if (parsedAnswer.body.querySelector('li')) { // Pokud jsou správné odpovědi definovány pomocí odrážkového / číslovaného seznamu
				parsedAnswer.querySelectorAll("li").forEach((item, i) => {
					this.correctAnswers.push(item.innerText);
				});
			}
		},

		evaluateAnswer() {
			this.noInput = false;
			if (this.inputText) { // Pokud něco napsal do input pole
				if (this.correctAnswers.includes(this.inputText.trim().toString())) {
					this.correctlyEvaluatedAnswer(this.$props.questionIndex);
				} else {
					this.incorrectlyEvaluatedAnswer(this.$props.questionIndex);
				}
			} else { // Pokud nic nenapsal do input pole
				console.log('trigger');
				this.noInput = true;
			}
		}
	},
};
</script>

<style lang="scss">

.result-in-enter-to {
	animation: swing-top-bck 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) reverse both;
}

.result-in-leave-to {
	animation: swing-top-bck 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2019-8-9 22:50:22
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swing-top-bck
 * ----------------------------------------
 */

@keyframes swing-top-bck {
	0% {
		transform: rotateX(0);
		transform-origin: top;
	}
	100% {
		transform: rotateX(-90deg);
		transform-origin: top;
	}
}

</style>
